#import "./sms-edition-light-fragment.graphql"

fragment SmsBroadcastLightFragment on SmsCampaign {
    id
    edition {
        ...SmsEditionLightFragment
    }
    owner {
        id
        name
    }
}
